import getDomain from './getDomain';

export default (url, isThatDomain) => {
  return getDomain(url) === getDomain(isThatDomain);
};
